<template>
    <div class="editable-text" :class="{multiline, empty: !value.length}">
        <div class="edit" v-if="is_editing">
            <textarea v-if="multiline" type="text" class="form-control" v-model="value"></textarea>
            <input v-else :type="type" class="form-control" v-model="value" @keyup.enter="save()" @keyup.esc="reset()">
            <div class="actions">
                <a class="action" href="#" @click.prevent.stop="reset()"><icon-reset size="18" color="danger"/></a>
                <a class="action" href="#" @click.prevent.stop="save()"><icon-check size="18" color="success" /></a>
            </div>
        </div>
        <div class="preview" v-else  @click.prevent.stop="edit()">
            {{ value }}
        </div>
    </div>
</template>

<script>
import IconCheck from "@/Icons/IconCheck";
import IconReset from "@/Icons/IconReset";
export default {
    name: "EditableText",
    components: {IconReset, IconCheck},
    emits: ['update:modelValue', 'change'],
    props: {
        modelValue: {
            type: [String, Number],
            default: '',
        },
        multiline: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'text',
        },
    },

    data(){
        return {
            value: '',
            is_editing: false,
        }
    },

    methods: {
        edit(){
            this.is_editing = true;
        },

        reset(){
            this.value = this.modelValue;
            this.is_editing = false;
        },

        save(){
            this.$emit('change', this.value);
            this.$emit('update:modelValue', this.value);
            this.is_editing = false;
        }
    },

    mounted() {
        this.reset();
    }

}
</script>

<style lang="scss" scoped>
.editable-text{
    position: relative;
    transition: background-color .3s;

    &:hover{
        background: rgba($dark, 0.1);
    }
}

.form-control{
    padding-right: 3rem;
}

.actions{
    position: absolute;
    bottom: 50%;
    right: 0.3rem;
    transform: translateY(50%);
    display: flex;
    font-size: 0.9rem;
    font-weight: $font-weight-normal;

    .action{
        margin-left: .2rem;
        padding: 0.3rem 0.1rem;
    }
}

.multiline{
    .actions{
        bottom: 0.3rem;
        transform: translateY(0);
    }
}

.preview{
    padding: .3rem 0 .3rem 0;
    cursor: text;
}

.empty{
    .preview{
        padding: .5rem 4rem .8rem 4rem;
    }
}
</style>
